import React, { useState , useEffect} from 'react';
import TopBar from '../Tools/Topbar'; // Component for the top navigation bar
import LeftSide from '../Tools/LeftSidebar'; // Component for the left sidebar
import Settings from '../Tools/Setting/Settings'; // Component for settings panel
import useSettings from '../Tools/Setting/useSettings'; // Custom hook for managing settings
import EmergencyResponseBarChart from '../EMS/Chart/Overview/EmergencyResponseBarChart';
import CasesRespondedBarChart from '../EMS/Chart/Overview/CasesRespondedBarChart';
import CasesTransportedBarChart from '../EMS/Chart/Overview/casesTransportedChart';
import ResourceUtilizationChart from '../EMS/Chart/Overview/ResourceUtilizationChart';
import axiosInstance from '../../../api';



// Component: Displays the main dashboard with placeholder content
const EMSDashboard = () => {
  // State to manage sidebar visibility
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  // Function to toggle sidebar visibility
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Use custom settings hook for managing user preferences
  const { settings, updateSetting, handleColorTheme } = useSettings();

    const [stats, setStats] = useState({
      readyAmbulances: 0,
      readyTeams: 0,
      inventoryLevel: 0,
      readyDevices: 0,
      todayCases: 0,
    });
     
    
  
    useEffect(() => {
        const fetchStats = async () => {
          try {
            const response = await axiosInstance.get('/ems/dashboard-numbers');
            const data = response.data.data || response.data;
    
            setStats({
              readyAmbulances: data.total_available_vehicle || 0,
              readyTeams: data.ready_teams || 0,
              inventoryLevel: data.inventory_level || 0,
              readyDevices: data.ready_medical_devices || 0,
              todayCases: data.today_cases || 0,
            });
          } catch (err) {
            console.error('Error fetching dashboard numbers:', err);
          } 
        };
    
        fetchStats();
      }, []);

        

  // Render the component UI
  return (
    <>
    <style>
      {`
      .widget-top-panel {display: flex; align-items: center; justify-content: space-between; }
      .dash-top-widget-panel .card .left-side p{width: 90%;}
      `}
    </style>
      
      
    
        <div id="main-wrapper">
      {/* Render the left sidebar with toggle functionality */}
      <LeftSide isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main content wrapper with conditional sidebar-closed class */}
      <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
        {/* Render the top navigation bar */}
        <TopBar toggleSidebar={toggleSidebar} />
        <div className="body-wrapper">
          <div className="container-fluid">
            {/* Render the settings panel for user preferences */}
            <Settings
              updateSetting={updateSetting}
              handleColorTheme={handleColorTheme}
              settings={settings}
            />

           {/* Display key statistics in card format */}
            <div className="row dash-top-widget-panel mt-4">
              <div className="col-lg-4 mb-3">
                <div className="card border border-primary p-4 mb-0 zoom-in bg-primary-subtle shadow-none h-100">
                  <div className="card-display">
                    <div className="left-side">
                      <h5>Ready Ambulances</h5>
                      <h2 className="text-primary fw-bolder fs-12">{stats.readyAmbulances}</h2>
                      <p className="mb-0">Available and ready for immediate deployment</p>
                    </div>
                    <div className="icon fs-12">
                      <i className="ti ti-ambulance text-primary"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-3">
                <div className="card border border-danger p-4 mb-0 zoom-in bg-danger-subtle shadow-none h-100">
                  <div className="card-display">
                    <div className="left-side">
                      <h5>Ready Teams</h5>
                      <h2 className="text-danger fw-bolder fs-12">{stats.readyTeams}</h2>
                      <p className="mb-0">Ready to respond to emergencies</p>
                    </div>
                    <div className="icon fs-12">
                      <i className="ti ti-users text-danger"></i>
                     
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-3">
                <div className="card border border-success mb-0 p-4 zoom-in bg-success-subtle shadow-none h-100">
                  <div className="card-display">
                    <div className="left-side">
                      <h5>Inventory Level</h5>
                      <h2 className="text-success fw-bolder fs-12">{stats.inventoryLevel}%</h2>
                      <p className="mb-0">Current essential medical supplies</p>
                    </div>
                    <div className="icon fs-12">
                      <i className="ti ti-package text-success"></i>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div className="row align-items-start">
                <div className="col-lg-6 mb-3">
                  <div className="card border border-warning mb-0 p-4 zoom-in bg-warning-subtle shadow-none h-100">
                    <div className="card-display">
                      <div className="left-side">
                        <h5>Ready Equipment</h5>
                        <h2 className="text-warning fw-bolder fs-12">{stats.readyDevices}</h2>
                        <p className="mb-0">Currently assigned to live cases</p>
                      </div>
                      <div className="icon fs-12">
                        <i className="ti ti-first-aid-kit text-warning"></i>
                      </div>
                    </div>
                  </div>
                </div>
              {/* Right Stats Card */}
                <div className="col-lg-6  mt-lg-0 mt-4">
                  <div className="d-flex align-items-center justify-content-center h-100">
                    <div className="card border border-info mb-0 p-4 zoom-in bg-info-subtle shadow-none w-100">
                      <div className="card-display d-flex w-100 align-items-end justify-content-between">
                        {/* Left Side */}
                        <div className="left-side">
                          <h5>Today</h5>
                          <h2 className="text-info fw-bolder fs-12">{stats.todayCases}</h2>
                          <p className="mb-0">
                            Last updated: 5 mins ago
                          </p>
                        </div>
                        {/* Icon */}
                        <div className="icon fs-12">
                          <i className="ti ti-first-aid-kit text-info"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
            
            {/* Purpose: Display Emergency Response and Cases Responded bar charts */}
            <div className="row">
              <div className="col-lg-6 mb-3">
                <EmergencyResponseBarChart />
              </div>
              <div className="col-lg-6 mb-3">
                <CasesRespondedBarChart />
              </div>
            </div>
            {/* Display Cases Transported bar chart */}
            <div className="row m-0">
              <CasesTransportedBarChart />
            </div>
            {/* Display Resource Utilization chart and today's cases stats */}
            <div class="card p-4 mt-4"> 
              <div className="row">
                {/* Left Chart */}
                <div className="col-lg-12">
                  <ResourceUtilizationChart />
                </div>

                
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar toggle overlay */}
      <div className="dark-transparent sidebartoggler" onClick={toggleSidebar}></div>
    </div>
    </>
  );
};

// Export the component as the default export
export default EMSDashboard;